export default __webpack_public_path__ + "static/media/DSC02624 Large.ff01b4e0.jpg";